import { forwardRef } from 'react';
import { ChevronUp } from '@core/assets/ChevronUp';
import { AccessibleIcon } from '@core/components/AccessibleIcon/AccessibleIcon';
import { useContextTranslation } from '@core/i18n';
import { IconButton } from './PlayerDeckContainer.styles';
/**
 *
 */
export const ChevronUpButton = forwardRef((props, ref) => {
    const { t } = useContextTranslation();
    return (<IconButton {...props} ref={ref}>
      <AccessibleIcon src={<ChevronUp label={''} aria-hidden/>} height="100%" width="100%" label={t('Expand Products')}/>
    </IconButton>);
});
